export const validateCurrency = (message: string) => (value: any) =>
    /^[A-Z]{3}$/.test(value) ? undefined : message;
